<main>
  <header
    *ngIf="showcase.agent"
    class="custom-container no-page-break contact-agent flex flex-col md:flex-row gap-2.5 justify-between print:flex-row"
  >
    <div class="md:hidden lg:block print:hidden">
      <h2 class="inline-block">Contact agent</h2>
    </div>
    <div
      class="flex flex-row items-center gap-2.5"
      *ngIf="showcase.agent.full_name"
    >
      <mat-icon>person</mat-icon>
      <div>
        {{ showcase.agent.full_name }}
      </div>
    </div>
    <div *ngIf="showcase.agent.phone" class="flex flex-row items-center gap-2.5">
      <mat-icon>phone</mat-icon>
      <div>
        <a class="block" [href]="'tel:' + showcase.agent.phone">
          {{ showcase.agent.phone | phone }}
        </a>
        <a class="block" [href]="'tel:' + showcase.agent.secondary_phone">
          {{ showcase.agent.secondary_phone | phone }}
        </a>
      </div>
    </div>
    <a
      *ngIf="showcase.agent.email"
      class="flex flex-row items-center gap-2.5"
      [href]="'mailto:' + showcase.agent.email"
      target="_blank"
    >
      <mat-icon>email</mat-icon>
      <div>
        {{ showcase.agent.email }}
      </div>
    </a>
  </header>

  <div
    *ngIf="showcase.subject"
    class="subject custom-container"
  ><h2 class="inline-block">{{ showcase.subject }}</h2></div>

  <div
    *ngIf="showcase.message"
    class="message custom-container"
  >{{ showcase.message }}</div>

  <div
    *ngFor="let showcase_property of showcase.showcases_properties; let last = last"
    [ngClass]="{ 'page-break-after': !last}"
  >
    <app-house-details
      [property]="showcase_property.property"
      [withLike]="true"
      [likeDislike]="showcase_property.status"
      (feedback)="sendFeedback(showcase_property, $event)"
    >
    </app-house-details>
  </div>
</main>
